import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import './index.css';
import RootApp from '@app/root-app';
import store from './store/store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { queryClient } from '@config/query-client';
import { createRoot } from 'react-dom/client';
import { initSentry } from '@config/sentry-config';
import { initAmplitude } from '@config/amplitude-config';
import { SERVICE } from '@config/environment';
import { EService } from '@datatype/type';

// ############### sentry ###############
initSentry();

// ############### amplitude ###############
initAmplitude();

// ############### redux persist ###############
const persistor = persistStore(store);
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        {/*{process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}*/}
        {/* TODO: github page: hash router, s3: browser router로 바꾸기 */}
        <BrowserRouter basename='/'>
          <RootApp />
        </BrowserRouter>
      </QueryClientProvider>
    </PersistGate>
  </Provider>,
  // </React.StrictMode>,
);

// servicer worker는 https 또는 localhost에서 테스트할 수 있으며, npm run serve로 테스트
if (SERVICE === EService.MOASHELF) {
  serviceWorkerRegistration.register();
}
